import { EmbeddingIndex } from '@/Workspaces/Embedding'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
    '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/',
)({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <EmbeddingIndex />
    )
}
